<template>
  <div :class="!isMobile ? 'container' : ''">
    <div :class="!isMobile ? 'user_profile_form' : 'user_profile_form_mobile'">
      <div class="container">
        <el-row :gutter="!isMobile ? 24 : 0">
          <el-col :span="!isMobile ? 18 : 24">
            <div :class="!isMobile ? 'my_container-card' : ''">
              <el-card :class="!isMobile ? 'box-card' : ''">
                <div v-if="!isMobile" slot="header" class="profile_header">
                  <span class="my_container-card-title">
                    Профиль пользователя +{{ userInfo.phone }}
                  </span>
                </div>
                <section :class="!isMobile ? 'my_container' : ''">
                  <el-form
                    ref="profileForm"
                    :model="user"
                    :rules="rules"
                    label-position="top"
                    label-width="100px"
                    class="user_form"
                  >
                    <el-row v-if="isMobile">
                      <el-col :span="24">
                        <h3>Укажите ваши личный данные</h3>
                        <el-form-item prop="fio">
                          <el-input
                            v-model="user.fio"
                            placeholder="Укажите ФИО"
                            @input="toCapital"
                          />
                        </el-form-item>
                        <el-form-item prop="passport">
                          <el-input
                            v-model="user.passport"
                            placeholder="Укажите номер паспорта (без пробелов)"
                          />
                        </el-form-item>
                        <el-form-item>
                          <el-input
                            v-model="user.email"
                            placeholder="Укажите email"
                          />
                        </el-form-item>
                        <el-form-item label="День рождения:">
                          <el-date-picker
                            id="user_birthday"
                            v-model="user.birthday"
                            class="user_birthday_profile"
                            type="date"
                            placeholder="Укажите дату рождения"
                            value-format="yyyy-MM-dd"
                            format="dd.MM.yyyy"
                          />
                        </el-form-item>
                        <el-form-item
                          label="Паспорт или водительское удостоверение:"
                        >
                          <upload-document-modal
                            name-document="Паспорт"
                            :data-edit="documents.user"
                            :source-id="documents.user.sourceId"
                            :need-additional="false"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-if="!isMobile" :gutter="24">
                      <el-col :span="12">
                        <el-form-item label="Фамилия Имя Отчество" prop="fio">
                          <el-input
                            v-model="user.fio"
                            placeholder="Укажите ФИО"
                            class="capitalize-text"
                            @input="toCapital"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Номер паспорта" prop="passport">
                          <el-input
                            v-model="user.passport"
                            placeholder="Укажите номер паспорта (без пробелов)"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-if="!isMobile" :gutter="24">
                      <el-col :span="12">
                        <el-form-item prop="email" label="Email">
                          <el-input v-model="user.email" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Файл подтверждение личности">
                          <upload-document-modal
                            name-document="Паспорт"
                            :data-edit="documents.user"
                            :source-id="documents.user.sourceId"
                            :need-additional="false"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-if="!isMobile" :gutter="24">
                      <el-col :span="12">
                        <el-form-item label="День рождения">
                          <el-date-picker
                            id="user_birthday"
                            v-model="user.birthday"
                            class="user_birthday_profile"
                            type="date"
                            placeholder="Укажите дату рождения"
                            value-format="yyyy-MM-dd"
                            format="dd.MM.yyyy"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <power-of-attorney />
                      </el-col>
                    </el-row>
                  </el-form>
                </section>
                <div class="action_user_form">
                  <el-button
                    type="success"
                    :loading="loading"
                    @click="postProfile"
                  >
                    Сохранить
                  </el-button>
                </div>
                <section v-if="isMobile" class="org_section">
                  <organizations
                    :organizations="userInfo.profile.user_organizations"
                    :current="userInfo.current"
                    :user-id="userInfo.id"
                  />
                </section>
              </el-card>
            </div>
          </el-col>
          <el-col v-if="!isMobile" :span="6">
            <hint />
          </el-col>
        </el-row>
        <section v-if="!isMobile" class="org_section">
          <span class="org_title"> Привязанные организации: </span>
          <organizations
            :organizations="userInfo.profile.user_organizations"
            :current="userInfo.current"
            :user-id="userInfo.id"
          />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_PROFILE } from '@/store/actions/userprofile'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { capital_letter } from '@/helpers/functions'
import { mapGetters } from 'vuex'
import Hint from '@/components/Hints/Hint'
import Organizations from './components/Organizations'
import PowerOfAttorney from './components/PowerOfAttorney'
import UploadDocumentModal from '@/components/Upload/UploadDocumentModal'

const Profile = RepositoryFactory.get('profile')

export default {
  name: 'UserProfile',
  components: {
    UploadDocumentModal,
    Hint,
    Organizations,
    PowerOfAttorney,
  },
  data() {
    return {
      loading: false,
      user: {
        fio: '',
        passport: '',
        email: '',
        birthday: '',
      },
      documents: {
        user: {
          sourceModelName: 'users',
          sourceId: this.userInfo,
          documentType: 'passport',
        },
      },
      rules: {
        fio: [
          {
            required: true,
            message: 'ФИО обязательно для заполнения',
            trigger: 'blur',
          },
        ],
        email: [
          {
            type: 'email',
            message: 'Введите корректный email',
            trigger: ['blur', 'change'],
          },
        ],
        passport: [
          {
            required: true,
            message: 'Данные паспорта обязательны для заполнения',
            trigger: 'blur',
          },
          {
            min: 10,
            max: 10,
            message: 'Значение «Passport» должно содержать 10 символов',
            trigger: 'blur',
          },
        ],
      },
      source_id: 0,
      source_model_id: 1,
    }
  },
  computed: {
    ...mapGetters({ userInfo: 'userProfile/userInfo' }),
    profile() {
      const { fio, passport, email, birthday } = this.userInfo.profile

      return {
        fio,
        passport,
        email,
        birthday,
      }
    },
    isCarrierInfo() {
      const { fio, passport } = this.userInfo.profile

      return this.isDriverRole && (!fio || !passport)
    },
  },
  watch: {
    profile(data) {
      if (!this.isCarrierInfo && !this.userInfo.profile.has_drivers) {
        this.$router.push({ path: '/driver/add' })
      }
      this.user = { ...data }
    },
  },
  created() {
    this.user = { ...this.profile }

    if (!this.user.fio || !this.user.fio.length) {
      const org = this.getCurrentUserOrganization()

      if (org.length > 0) {
        this.user.fio =
          org[0].organization.short_name && this.user
            ? this.isIP(org[0].organization.short_name)
            : ''
      }
    }
    this.documents.user.sourceId = this.userInfo.id
  },
  methods: {
    isIP(short_name) {
      return short_name.includes('ИП ', 0) ? short_name.substr(3) : ''
    },
    toCapital(val) {
      this.user.fio = capital_letter(val)
    },
    alertSuccess(message) {
      this.$message({
        type: 'success',
        message,
        showClose: true,
        duration: 5000,
        offset: 50,
      })
    },
    postProfile() {
      let { fio, passport, email, birthday } = this.user

      this.$refs['profileForm'].validate(valid => {
        if (valid) {
          this.loading = true
          Profile.profile(fio, passport, email, birthday)
            .then(res => {
              if (res.status === 200) {
                // todo: custom message using res.data.user_type
                this.alertSuccess(
                  'Ваш профиль успешно сохранен, теперь можно перейти к добавлению водителей и автомобилей.',
                )
                this.$store.dispatch(`userProfile/${GET_PROFILE}`)
              }
            })
            .catch(err => console.log(err))
            .finally(() => (this.loading = false))
        }
      })
    },
  },
}
</script>

<style lang="sass">
.user_profile_form
  margin-top: 50px
  .my_container-card
    .el-card__header
      border: none
      .profile_header
        display: flex
        align-items: center
        justify-content: space-between
        padding: 20px 15px
      .my_container-card-title
        display: block
    .my_container
      background: none
      padding: 0 15px
  .toggle_user_type
    height: 40px
    margin: 20px 0
    display: flex
    justify-content: flex-end
  .el-form--label-top .el-form-item__label
    padding: 0
  .user_birthday_profile
    width: 65% !important
  .action_user_form
    display: flex !important
    align-items: center !important
    padding: 20px 15px 15px
  .user_form
    .el-form-item__content
      width: 100%
  .org_section
    margin: 35px 0
    .org_title
      font-size: 22px
      line-height: 17px
.user_profile_form_mobile
  padding-top: 20px
  padding-bottom: 70px
  .user_form
    .el-form-item__label
      line-height: normal
</style>
